var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.33 5.33H10.67a5.35 5.35 0 0 0-5.34 5.34v48L16 48h37.33c2.94 0 5.34-2.4 5.34-5.33v-32c0-2.94-2.4-5.34-5.34-5.34Zm0 37.34H13.8l-3.12 3.12V10.67h42.66v32ZM18.67 24H24v5.33h-5.33V24ZM40 24h5.33v5.33H40V24Zm-10.67 0h5.34v5.33h-5.34V24Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.a89e5411.svg";
export { ForwardRef as ReactComponent };